export default __webpack_public_path__ + "static/media/Profile.d82d06b2.svg";